module.exports = __webpack_public_path__ + "static/media/Secondary.bc57c240.png";